import React, { FC } from 'react';
import LinearGradient from 'react-native-linear-gradient';

import { Theme } from '@constants';

import { styles } from './styles';

export const TWCBackground: FC = ({ children }) => (
  <LinearGradient
    colors={[Theme.gradients.background.start, Theme.gradients.background.end]}
    style={styles.linearGradient}
  >
    {children}
  </LinearGradient>
);
